import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Element2gr7ezmxqaln7 as Element } from '../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import {
  JobImpl2fbttqo93wxua as JobImpl,
  JobNode$invoke$refodp2hegnnnnc as JobNode$invoke$ref,
  JobSupport3fdjh0rbee4be as JobSupport,
  JobNode2tu3g3s3xsko1 as JobNode,
} from './JobSupport.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  return Key_instance;
}
function cancel$default(cause, $super) {
  cause = cause === VOID ? null : cause;
  var tmp;
  if ($super === VOID) {
    this.cancel_hkmm2i_k$(cause);
    tmp = Unit_instance;
  } else {
    tmp = $super.cancel_hkmm2i_k$.call(this, cause);
  }
  return tmp;
}
var JobClass;
function Job() {
  if (JobClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Job', VOID, VOID, [Element()], [0]);
    JobClass = $;
  }
  return JobClass;
}
function Job_0(parent) {
  parent = parent === VOID ? null : parent;
  return new (JobImpl())(parent);
}
function get_job(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.get_y2st91_k$(Key_instance);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.error' call
    var message = "Current context doesn't contain Job in it: " + toString(_this__u8e3s4);
    throw IllegalStateException().new_kotlin_IllegalStateException_w47ei6_k$(toString(message));
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
var NonDisposableHandleClass;
function NonDisposableHandle() {
  if (NonDisposableHandleClass === VOID) {
    class $ {
      get_parent_hy4reb_k$() {
        return null;
      }
      dispose_3nnxhr_k$() {
      }
      childCancelled_hsnipy_k$(cause) {
        return false;
      }
      toString() {
        return 'NonDisposableHandle';
      }
    }
    initMetadataForObject($, 'NonDisposableHandle');
    NonDisposableHandleClass = $;
  }
  return NonDisposableHandleClass;
}
var NonDisposableHandle_instance;
function NonDisposableHandle_getInstance() {
  return NonDisposableHandle_instance;
}
function invokeOnCompletion(_this__u8e3s4, invokeImmediately, handler) {
  invokeImmediately = invokeImmediately === VOID ? true : invokeImmediately;
  var tmp;
  if (_this__u8e3s4 instanceof JobSupport()) {
    tmp = _this__u8e3s4.invokeOnCompletionInternal_5jxuhy_k$(invokeImmediately, handler);
  } else {
    var tmp_0 = handler.get_onCancelling_k07uns_k$();
    tmp = _this__u8e3s4.invokeOnCompletion_sct3wq_k$(tmp_0, invokeImmediately, JobNode$invoke$ref(handler));
  }
  return tmp;
}
function ensureActive(_this__u8e3s4) {
  var tmp0_safe_receiver = _this__u8e3s4.get_y2st91_k$(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else {
    ensureActive_0(tmp0_safe_receiver);
  }
}
function ensureActive_0(_this__u8e3s4) {
  if (!_this__u8e3s4.get_isActive_quafmh_k$())
    throw _this__u8e3s4.getCancellationException_8i1q6u_k$();
}
var ParentJobClass;
function ParentJob() {
  if (ParentJobClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ParentJob', VOID, VOID, [Job()], [0]);
    ParentJobClass = $;
  }
  return ParentJobClass;
}
function disposeOnCompletion(_this__u8e3s4, handle) {
  return invokeOnCompletion(_this__u8e3s4, VOID, new (DisposeOnCompletion())(handle));
}
var DisposeOnCompletionClass;
function DisposeOnCompletion() {
  if (DisposeOnCompletionClass === VOID) {
    class $ extends JobNode() {
      constructor(handle) {
        super();
        this.handle_1 = handle;
      }
      get_onCancelling_k07uns_k$() {
        return false;
      }
      invoke_py2q9a_k$(cause) {
        return this.handle_1.dispose_3nnxhr_k$();
      }
    }
    initMetadataForClass($, 'DisposeOnCompletion');
    DisposeOnCompletionClass = $;
  }
  return DisposeOnCompletionClass;
}
//region block: init
Key_instance = new (Key())();
NonDisposableHandle_instance = new (NonDisposableHandle())();
//endregion
//region block: exports
export {
  Key_instance as Key_instancepi2bbb0csu5f,
  NonDisposableHandle_instance as NonDisposableHandle_instance1i3r88cx0n1ry,
  cancel$default as cancel$default18ta0nr79mwbn,
  Job_0 as Job13y4jkazwjho0,
  Job as Job29shfjfygy86k,
  ParentJob as ParentJob1a3idoswyjefg,
  disposeOnCompletion as disposeOnCompletion1zvxmj809ax5i,
  ensureActive as ensureActive2yo7199srjlgl,
  ensureActive_0 as ensureActive159jflbg22qd8,
  invokeOnCompletion as invokeOnCompletion3npqdfp2wzhn6,
  get_job as get_job2zvlvce9o9a29,
};
//endregion

//# sourceMappingURL=Job.mjs.map
